import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import React from 'react'
import Companies from '../Integrations/Companies'
import FAQ from '../Integrations/FAQ'
import FeaturesDoc from '../Integrations/FeaturesDoc'
import HomeReviewBox from '../Integrations/HomeReviewBox'
import IntegrationPopupClients from '../Integrations/IntegrationPopupClient'
import IntegrationPopupTestimonials from '../Integrations/IntegrationPopupTestmonial'
import ProductLogo from '../Integrations/ProductLogo'
import Layout from '../layout'
import Metatags from '../Metatags'
import ComparisonTable from './ComparisonTable'
import WhyOptinlyBestAlternative from './WhyOptinlyBestAlternative'


const ComparisonTemplate = ({
    integrationApp, otherProductLogo,
    homeTitle, homeDescription,
    FAQQuestion1, FAQAnswer1,
    FAQQuestion2, FAQAnswer2,
    FAQQuestion3, FAQAnswer3,
    FAQQuestion4, FAQAnswer4,
    FAQQuestion5, FAQAnswer5,
    websiteIntegrationArray,
    integrationArray,
    pricingArray,
    campaignsArray,
    metaTitle,
    metaDescription
}) => {

    const data = useStaticQuery(graphql`
        query ComparisonHomeBannerReviewQuery {
            AppsumoImage: file(
                absolutePath: {regex: "/images/integration-pages/"}
                name: {eq: "appsumo-rating"}
                ) {
                childImageSharp {
                    gatsbyImageData(placeholder: NONE, quality: 100)
                }
            }

            StarGroupImage: file(
                absolutePath: {regex: "/images/integration-pages/"}
                name: {eq: "star-group"}
                ) {
                childImageSharp {
                    gatsbyImageData(placeholder: NONE, quality: 100)
                }
            }

            UserImage: file(
                absolutePath: {regex: "/images/integration-pages/"}
                name: {eq: "user"}
                ) {
                childImageSharp {
                    gatsbyImageData(placeholder: NONE, quality: 100)
                }
            }

            EyeImage: file(
                absolutePath: {regex: "/images/integration-pages/"}
                name: {eq: "eye"}
                ) {
                childImageSharp {
                    gatsbyImageData(placeholder: NONE, quality: 100)
                }
            }

        }
    `)

    const appsumoImage = getImage(data.AppsumoImage)
    const starGroupImage = getImage(data.StarGroupImage)
    const userImage = getImage(data.UserImage)
    const eyeImage = getImage(data.EyeImage)

    return (
        <>         
            <Layout isIntegrationPage={true}>

                <Metatags
                    title={metaTitle}
                    description={metaDescription}
                />
            
                {/* HOME BANNER SECTION */}
                <section className="relative w-screen h-700px xs:h-650px md:h-600px home-banner-background">

                    {/* MAIN SECTION */}
                    <div className="w-full pt-10 mx-auto text-center 2xl:w-4/5 lg:pt-24">

                        <div className="w-full mx-auto lg:w-3/5 2xl:w-1/2">
                            <ProductLogo isComparisionPage={true} integrationApp={integrationApp} otherProductLogo={otherProductLogo} />
                        </div>

                        <div className="py-14 flex flex-col space-y-2.5">
                            <h1 className="text-2xl font-semibold text-center text-primary md:text-28px lg:text-32px font-poppins">{homeTitle}</h1>
                            <p className="w-4/5 mx-auto text-sm font-normal text-center 2xl:w-3/5 text-font_primary md:text-base lg:text-lg font-roboto">{homeDescription}</p>
                        </div>

                        <div>
                            <a href="https://app.optinly.com/" target="_blank" className="px-6 py-2 text-sm font-semibold text-center rounded-lg text-button_text md:text-base lg:text-lg bg-custom_yellow focus:outline-none hover:text-button_text home-button-shadow">View Comparison </a>
                        </div>

                    </div>

                    {/* REVIEW SECTION */}
                    <HomeReviewBox
                        appsumoImage={appsumoImage}
                        starGroupImage={starGroupImage}
                        userImage={userImage}
                        eyeImage={eyeImage}
                    />

                </section>
                

                {/* COMPANIES */}
                <Companies /> 

               {/* Table Section */}
               <ComparisonTable 
                    integrationApp={integrationApp}
                    websiteIntegrationArray={websiteIntegrationArray}
                    integrationArray={integrationArray}
                    pricingArray={pricingArray}
                    campaignsArray={campaignsArray}
                />

               {/* WHY OPTINLY BEST ALTERNATIVE */}
                <WhyOptinlyBestAlternative integrationApp={integrationApp} />

                {/* CUSTOMER REVEIW */}
                <IntegrationPopupTestimonials />

                {/* INTEGRATIONS COMPANIES */}
                <IntegrationPopupClients />

                {/* FAQ */}
                <FAQ 
                    FAQQuestion1 = {FAQQuestion1}
                    FAQAnswer1 = {FAQAnswer1}

                    FAQQuestion2 = {FAQQuestion2}
                    FAQAnswer2 = {FAQAnswer2}

                    FAQQuestion3 = {FAQQuestion3}
                    FAQAnswer3 = {FAQAnswer3}

                    FAQQuestion4 = {FAQQuestion4}
                    FAQAnswer4 = {FAQAnswer4}

                    FAQQuestion5 = {FAQQuestion5}
                    FAQAnswer5 = {FAQAnswer5}
                />

                {/* FOOTER */}
                {/* <IntegrationFooter /> */}
            </Layout>
        </>
    )
}

export default ComparisonTemplate
